export default __webpack_public_path__ + "static/media/regulatory--no-parking-bicycles-or-motorcycles--g1.932ed75c.png";